import React from 'react';
import { QuoteTextTemplatesManager } from '../../../components';

function QuoteTextTemplatesForm() {
    return <QuoteTextTemplatesManager />;
}

export default QuoteTextTemplatesForm;
